

















import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Contacts extends Vue { 
    @Prop() public changeState: any

	productType = null as any
	productTypeData = [
		{ id: 1 , name: 'ทั้งหมด', value: 0 },
		{ id: 2 , name: 'บ้าน', value: 1 },
		{ id: 3 , name: 'คอนโด', value: 2 },
		{ id: 4 , name: 'ทาวน์โฮม', value: 5 },
	] as any

	updateState () {
		if (this.productType !== null)
			this.changeState("productType", this.productType.value)
		if (this.productType === null)
			this.changeState("productType", "")
	}
}
